__turbopack_context__.v({
  "arrow": "deviceItem-module-scss-module__mcPlgW__arrow",
  "buttons-container": "deviceItem-module-scss-module__mcPlgW__buttons-container",
  "container": "deviceItem-module-scss-module__mcPlgW__container",
  "container-nested": "deviceItem-module-scss-module__mcPlgW__container-nested",
  "container-selected": "deviceItem-module-scss-module__mcPlgW__container-selected",
  "fade-in-ux308ek": "deviceItem-module-scss-module__mcPlgW__fade-in-ux308ek",
  "icon": "deviceItem-module-scss-module__mcPlgW__icon",
  "id": "deviceItem-module-scss-module__mcPlgW__id",
  "item": "deviceItem-module-scss-module__mcPlgW__item",
  "meter-list": "deviceItem-module-scss-module__mcPlgW__meter-list",
  "meter-list-header": "deviceItem-module-scss-module__mcPlgW__meter-list-header",
  "report": "deviceItem-module-scss-module__mcPlgW__report",
  "skeleton-reading": "deviceItem-module-scss-module__mcPlgW__skeleton-reading",
  "toggle": "deviceItem-module-scss-module__mcPlgW__toggle",
  "toggle-border": "deviceItem-module-scss-module__mcPlgW__toggle-border",
  "toggle-button": "deviceItem-module-scss-module__mcPlgW__toggle-button",
  "toggle-button-selected": "deviceItem-module-scss-module__mcPlgW__toggle-button-selected",
  "wrapper": "deviceItem-module-scss-module__mcPlgW__wrapper",
});
